import React, { Fragment, useEffect, useMemo, useState } from "react";
import BreadCrumbComp from "../../component/breadCrumb/breadCrump.js";
import { useDispatch, useSelector } from "react-redux";
import { LabelHeading } from "../../component/LabelHeader/labelHeader.style.js";

import { getDataDomainSubdomain } from "../../redux/accessManagement/accessManagement.action.js";
import { Container } from "../global/global.style.js";
import { PanelMenu } from "primereact/panelmenu";

import { ProgressSpinner } from "primereact/progressspinner";
import { Panel } from "primereact/panel";
import IconInputText from "../../component/iconInputText/iconInputText.js";
import { Button } from "primereact/button";
import { ButtonGroup } from "primereact/buttongroup";
import AddNewMember from "./addNewMember.js";

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

import ChangeMemberRoleDialog from "./ChangeMemberRoleDialog.js";
import ChangeMemberRolePermissionDialog from "./ChangeMemberPermissonRoleDialog.js";
import { ChangeUserRoleMutation } from "../../mutations/AccessManagementMutationHook.js";

import { useToast } from "../../context/ToastContext.js";
import { FilterMatchMode } from "primereact/api";
import { MultiSelect } from "primereact/multiselect";
import { UserTable } from "./UserTable.js";
import { AssetTable } from "./AssetDataTable.js";
import { GetDomainAndSubdomains } from "../../queries/appQueries.js";



export const multiSelectFilter = (options,key,data) => {
  let optionitem=Array.from(new Set(data?.map(user =>  user[key])))
  console.log(options);
  
   return (
     <MultiSelect
       value={options.value}
       options={optionitem?.map(user => ({ label: user, value: user }))}
       itemTemplate={(option) => {
         return (
         
             <span>{option.label}</span>
         
         );
       }}
       onChange={(e) => options.filterApplyCallback(e.value)}
       optionLabel="label"
       placeholder="Any"
       className="p-column-filter"
       maxSelectedLabels={1}
       style={{ minWidth: '14rem' }}
     />
   );
 };


 function RuleElevation() {
  const toast = useToast();
  const dispatch = useDispatch();

  // State for managing various UI elements
  const [enableChangeMemberRolePopUp, setEnableChangeMemberRolePopUp] = useState(false);
  const [enableChangeMemberPermissionRolePopUp, setEnableChangeMemberPermissionRolePopUp] = useState(false);
  const [enableNewMemberPopUp, setEnableNewMemberPopUp] = useState(false);
  const [selectedDomainItems, setSelectedDomainItems] = useState([]);
  const [activeTab, setActiveTab] = useState(0); // 0 for "Members", 1 for "Data Assets"

  const [selectedRows, setSelectedRows] = useState(null);

  // Redux state selectors
  const { steppersData } = useSelector((state) => state.crumbs);
  const { apiData } = useSelector((state) => state.accessManagement);

  const{data,isLoading}=GetDomainAndSubdomains()
  console.log(data,isLoading);
  
console.log(steppersData);

  // Filters for searching members
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_name: { value: null, matchMode: FilterMatchMode.IN },
    user_email: { value: null, matchMode: FilterMatchMode.IN },
    data_asset_name: { value: null, matchMode: FilterMatchMode.IN },
     region: { value: null, matchMode: FilterMatchMode.IN },
    country: { value: null, matchMode: FilterMatchMode.IN },
  });

  const resetFilters = () => {
    setFilters({
      global: { value: '', matchMode: FilterMatchMode.CONTAINS },
      user_name: { value: null, matchMode: FilterMatchMode.IN },
      user_email: { value: null, matchMode: FilterMatchMode.IN },
      data_asset_name: { value: null, matchMode: FilterMatchMode.IN },
        region: { value: null, matchMode: FilterMatchMode.IN },
    country: { value: null, matchMode: FilterMatchMode.IN },
    });
 
  };
  // Handles changes in the search input
  const onGlobalFilterChange = (e) => { const value = e.target.value; let _filters = { ...filters }; _filters['global'].value = value; setFilters(_filters)};

  // Fetch domain-subdomain data when the component mounts
  useEffect(() => {
    dispatch(getDataDomainSubdomain());
  }, [dispatch]);

  // Memoized Panel Menu Data
  const panelMenuData = useMemo(
    () =>
      apiData?.domainSubDomain?.data?.map((domain) => ({
        label: domain.domain_name,
        key: `${domain.domain_name}:D`,
        icon: "pi pi-database",
        items: domain.subdomains.map((subdomain) => ({
          label: subdomain.sub_domain_name,
          icon: "pi pi-database",
          template: (
            <div
              className={`p-menuitem-link ${
                selectedDomainItems[`${subdomain.sub_domain_name}:SD`] ? "highlighted" : ""
              }`}
            >
              <span className={subdomain.icon}></span>
              {subdomain.sub_domain_name}
            </div>
          ),
          key: `${subdomain.sub_domain_name}:SD`,
        })),
      })),
    [apiData?.domainSubDomain?.data, selectedDomainItems]
  );

  // Function to remove selected members
  const { mutate: deleteUser, isPending: isDeleting } = ChangeUserRoleMutation(
    () => {
      toast({ severity: "info", summary: "Confirmed", detail: "User Deleted Successfully.", life: 3000 });
      resetFilters()
    },
    (error) => {
      toast({ severity: "info", summary: "Error", detail: error.response.data.detail, life: 3000 });
    }
  );

  const acceptRemoveMember = () => {
    deleteUser(
      selectedRows.map((item) => ({
        ...item,
        end_date: Date.now(),
        last_modified_by: localStorage.getItem("userId"),
      }))
    );
  };



 
  return (
    <Fragment>
      <ConfirmDialog />

      {/* Change Role Popups */}
      {enableChangeMemberRolePopUp && <ChangeMemberRoleDialog userIds={selectedRows} onHide={() => setEnableChangeMemberRolePopUp(false)} />}
      {enableChangeMemberPermissionRolePopUp && <ChangeMemberRolePermissionDialog userIds={selectedRows} onHide={() => setEnableChangeMemberPermissionRolePopUp(false)} />}

      <BreadCrumbComp items={steppersData.RuleElevation} />

      {/* Loading Spinner */}
      {apiData.domainSubDomain.loading ? (
        <div style={{ width: "100%", textAlign: "center", lineHeight: window.innerHeight + "px", verticalAlign: "middle" }}>
          <ProgressSpinner />
        </div>
      ) : (
        <Container style={{ height: "85%",position:'relative' }}>
          <div className="grid">
            <div className="col-12">
              <LabelHeading>Rule Elevation</LabelHeading>
            </div>
          </div>

          <div className="grid" style={{ height: "100%",position:'relative' }}>
            {/* Side Panel Menu */}
            <div className="col-2" style={{ paddingTop: "10px", backgroundColor: "white", height: "100%", overflow: "auto" }}>
              <PanelMenu multiple expandedKeys={selectedDomainItems} model={panelMenuData} onExpandedKeysChange={setSelectedDomainItems} />
            </div>

            {/* Main Content */}
            <div className="col-10">
              <Panel style={{ height: "70px" }}>
                {/* <div className="grid"> */}
                  <div  style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'10px'}} >
                    <ButtonGroup>
                      {/* Tab Buttons */}
                      <Button onClick={() => { setActiveTab(0); setSelectedRows(null); }} raised outlined={activeTab != 0} label="Prepare Metadata" icon="pi pi-code" />
                      <Button onClick={() => { setActiveTab(1); setSelectedRows(null); }} outlined={activeTab != 1} raised label="Rule Elevation" icon="pi pi-database" />
                      <Button onClick={() => { setActiveTab(2); setSelectedRows(null); }} outlined={activeTab != 2} raised label="Promotion History" icon="pi pi-history" />
                    </ButtonGroup>
                    {activeTab===0&&<Button disabled={!selectedRows?.length} outlined label="Prepare Metadata" icon="pi pi-cog" />}
                     {activeTab===1&&<Button disabled={!selectedRows?.length} outlined label="Approve" icon="pi pi-cog" />}
                  </div>

                  {/* Search & Action Buttons */}
                  {/* <div className="col-4" style={{ textAlign: "right", display: "flex", gap: "15px", justifyContent: "end" }}> */}
                 

                    {/* <div style={{ width: "35%" }}>
                      <IconInputText
                        iconPosition="left"
                        style={{
                          width: "100%",
                          marginRight: "10px",
                          height: "40px",
                        }}
                        value={filters.global.value}
                        onChange={onGlobalFilterChange}
                        iconName="pi-search"
                        placeholderName="Search"
                      />
                    </div> */}

                  
                    {/* {!selectedRows?.length && activeTab === 0 && <Button label="Add Member" onClick={() => setEnableNewMemberPopUp(true)} icon="pi pi-plus" />}
                    {selectedRows?.length > 0 && activeTab === 0 && <>
                      <Button label="Remove Member" onClick={() => confirmDialog({ message: "Are you sure?", header: "Confirmation", accept: acceptRemoveMember })} icon={isDeleting ? "pi pi-spin pi-spinner" : "pi pi-minus"} />
                      <Button outlined label="Change Role" onClick={() => setEnableChangeMemberRolePopUp(true)} icon="pi pi-cog" />
                    </>}
                    {selectedRows?.length > 0 && activeTab === 1 && ( <> <Button outlined label="Change Permisson" onClick={() => setEnableChangeMemberPermissionRolePopUp(true) } icon="pi pi-cog" /> </> )} */}
                        
                
                  {/* </div> */}
                {/* </div> */}
              </Panel>

              {/* Member and Asset Tables */}
              <Panel style={{ height: "80%" }}>
                <UserTable resetFilters={resetFilters} filters={filters} selectedDomainItems={selectedDomainItems} selectedRows={selectedRows} setSelectedRows={setSelectedRows} />
                {/* {activeTab === 0 ? <UserTable resetFilters={resetFilters} filters={filters} selectedDomainItems={selectedDomainItems} selectedRows={selectedRows} setSelectedRows={setSelectedRows} /> : 
                <AssetTable resetFilters={resetFilters} filters={filters} selectedDomainItems={selectedDomainItems} selectedRows={selectedRows} setSelectedRows={setSelectedRows} />} */}
              </Panel>
            </div>
          </div>

          {enableNewMemberPopUp && <AddNewMember onHide={() => setEnableNewMemberPopUp(false)} />}
        </Container>
      )}
    </Fragment>
  );
}


export default RuleElevation;



